import React from 'react';
import PropTypes from 'prop-types';
import { Meteor } from 'meteor/meteor';
import { withTracker } from 'meteor/react-meteor-data';

import MapServerElements from '../../../api/MapServerElements/MapServerElements';
import { getName } from '../../../api/MapServerElements/map-server-element-operations';

import Loading from '../../components/Loading';
import MapServerElementEditor from '../../components/MapServerElementEditor';

import PageHeader from '../../atoms/PageHeader';

const EditMapServerElement = ({ history, loading, mapServerElement }) => {
  if (loading) {
    return <Loading />;
  }
  return (
    <>
      <PageHeader>
        <h4>{`Editing "${getName(mapServerElement)}"`}</h4>
      </PageHeader>
      <MapServerElementEditor history={history} mapServerElement={mapServerElement} />
    </>
  );
};

EditMapServerElement.defaultProps = {
  mapServerElement: {}
};

EditMapServerElement.propTypes = {
  mapServerElement: PropTypes.object,
  history: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired
};

export default withTracker(({ match }) => {
  const mapServerElementId = match.params.mapServerElement_id;
  const mapServerElementSub = Meteor.subscribe('mapServerElements');

  return {
    loading: !mapServerElementSub.ready(),
    mapServerElement: MapServerElements.findOne(mapServerElementId)
  };
})(EditMapServerElement);
